var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CampaignEditOffersList"}},[_c('Page',{attrs:{"title":((_vm.$t('Editing')) + " '" + (_vm.campaign.name) + "'"),"secondaryActions":[{
      label: _vm.$t('Notes'),
      onAction: function () { _vm.eventHub.$emit('showCampaignNotes', _vm.campaign.id) }
    }],"primaryAction":{
      label: _vm.$t('Add Offer'),
      onAction: function () { return _vm.addOffer(); },
      disabled: _vm.saving
    },"size":"fullWidth"}},[_c('campaign-edit-header',{attrs:{"campaign":_vm.campaign}}),(_vm.loading)?_c('LoadingLayout'):_vm._e(),(!_vm.loading)?_c('Layout',[_c('LayoutSection',[_c('Card',{attrs:{"title":_vm.$t('Offers'),"actions":[
            {
              label: _vm.$t('Export'),
              onAction: function () { return _vm.exportOffers(); },
              disabled: _vm.saving
            }
          ]}},[_c('Filters',{ref:"filters",attrs:{"filters":[
              {
                key: 'status',
                label: _vm.$t('Status'),
                type: 'select',
                placeholder: 'Select',
                multiple: true,
                options: [
                  { label: _vm.$t('Active'), value: 'enabled' },
                  { label: _vm.$t('Disabled'), value: 'disabled' }
                ]
              },
              {
                key: 'segmentId',
                label: _vm.$t('Segments'),
                type: 'select',
                placeholder: 'Select',
                options: _vm.formattedSegmentList,
                multiple: true
              },
              {
                key: 'validity',
                label: _vm.$t('Validity'),
                type: 'select',
                placeholder: 'Select',
                options: [
                  { label: _vm.$t('campaignEdit.segment.Outside validity period'), value: 'outside' },
                  { label: _vm.$t('campaignEdit.Inside validity period'), value: 'inside' }
                ]
              }
            ],"applied-filters":_vm.filter,"query":_vm.query,"required":""},on:{"update:applied-filters":_vm.updateFilter,"update:query":[_vm.setQuery,function($event){_vm.query=$event}]}}),_c('DataTable',{attrs:{"columns":[
              {
                key: 'id',
                label: _vm.$t('ID'),
                fixed: true,
                sortable: true
              },
              {
                key: 'displayText',
                label: _vm.$t('Display'),
                sortable: true
              },
              {
                key: 'code',
                label: _vm.$t('Code'),
                sortable: true
              },
              {
                key: 'status',
                label: _vm.$t('Status')
              },
              {
                key: 'min',
                label: _vm.$t('Min'),
                sortable: true
              },
              {
                key: 'validFromDate',
                label: _vm.$t('Start'),
                format: 'dateShort',
                sortable: true
              },
              {
                key: 'expiryDate',
                label: _vm.$t('End'),
                format: 'dateShort',
                sortable: true
              },
              {
                key: 'variant',
                label: _vm.$t('Variant'),
                sortable: true
              },
              {
                key: 'presented',
                label: _vm.$t('Presented')
              },
              {
                key: 'fullLanguage',
                label: _vm.$t('Language')
              },
              {
                key: 'numSegs',
                label: _vm.$t('# Segs'),
                sortable: true
              }
            ],"rows":_vm.formattedIncentives,"row-actions":function (row) { return (_vm.getRowActions(row)); },"sort":_vm.sortBy,"bulk-actions":_vm.bulkActions,"selected-ids":_vm.selectedIds,"pagination":{
              offset: _vm.offset,
              limit: _vm.limit,
              total: _vm.formattedIncentives.length,
              updateOffset: function (val) { return _vm.offset = val; },
              updateLimit: _vm.updateLimit
            },"compact":""},on:{"update:sort":function($event){_vm.sortBy=$event},"update:selectedIds":function($event){_vm.selectedIds=$event},"update:selected-ids":function($event){_vm.selectedIds=$event}},scopedSlots:_vm._u([{key:"col:displayText",fn:function(ref){
            var row = ref.row;
return [_vm._v("\n              "+_vm._s(row.displayText)+"\n              "),(row.condition)?_c('Caption',[_vm._v(_vm._s(row.condition))]):_vm._e()]}},{key:"col:id",fn:function(ref){
            var row = ref.row;
return [(!row.isDisabled)?_c('PageLink',{attrs:{"href":_vm.getOfferUrl(row)}},[_vm._v(_vm._s(row.id))]):[_vm._v(_vm._s(row.id))]]}},{key:"col:code",fn:function(ref){
            var row = ref.row;
return [(row.promoType === 'file')?_c('Badge',{attrs:{"status":"info"}},[_vm._v(_vm._s(row.code))]):(row.promoType === 'code')?[_vm._v(_vm._s(row.code))]:_vm._e()]}},{key:"col:status",fn:function(ref){
            var row = ref.row;
return [(!row.isDisabled)?_c('Badge',{attrs:{"status":"success"}},[_vm._v(_vm._s(_vm.$t('Active')))]):(row.isDisabled)?_c('Badge',{attrs:{"status":"warning"}},[_vm._v(_vm._s(_vm.$t('Inactive')))]):_vm._e(),_c('div',[(row.status === 'runOut')?_c('Badge',{attrs:{"status":"attention"}},[_vm._v(_vm._s(_vm.$t('campaignEdit.offer.Low Codes')))]):_vm._e()],1),_c('div',[(_vm.outsideValidityPeriod(row))?_c('Badge',{attrs:{"status":"info"}},[_vm._v(_vm._s(_vm.$t('campaignEdit.segment.Outside validity period')))]):_vm._e()],1)]}},{key:"col:numSegs",fn:function(ref){
            var row = ref.row;
return [(row.numSegs)?[_c('PageLink',{on:{"click":function($event){return _vm.showSegments(row)}}},[_vm._v(_vm._s(row.numSegs))])]:[_vm._v("0")]]}},{key:"col:variant",fn:function(ref){
            var row = ref.row;
return [(row.variant && !_vm.validVariant(row.variant))?_c('Badge',{attrs:{"status":"warning","tooltip":_vm.$t('campaignEdit.offer.listVariantToolTip')}},[_vm._v(_vm._s(row.variant))]):(row.variant)?[_vm._v(_vm._s(row.variant))]:[_vm._v("—")]]}}],null,false,3973651403)})],1),(_vm.singleUseCouponsEnabled && _vm.hasSingleUseCoupons)?_c('Card',[_c('CardSection',[_c('em',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('campaignEdit.offer.lowCodesThresholdMessage', { value: ("" + _vm.singleUseDisableThreshold)} ))}})])])],1):_vm._e()],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }